import { z } from "zod";

export const npiEnumerationTypeSchema = z.enum(["NPI-1", "NPI-2"]);

export type NpiEnumerationType = z.infer<typeof npiEnumerationTypeSchema>;
